<template>
    <div class="view-content view7">
        <div class="title">{{ $t('竞争优势') }}</div>
        <div class="ul">
            <div class="li-box" v-for="(item, index) in list" :key="index">
                <div class="li">
                    <div class="li-img-box"><img class="li-img" :src="item.img" /></div>
                    <div class="text-box">
                        <div class="li-title">{{ item.title }}</div>
                        <div class="li-text">{{ item.text }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'view7',
  data () {
    return {
        list: [
            {
                img: require('./img/1030/view7-1.png'),
                title: this.$t('极速公链'),
                text: this.$t('0.2 秒出块，支持百万级并发订单及支付交易。'),
            },
            {
                img: require('./img/1030/view7-2.png'),
                title: this.$t('全球合规'),
                text: this.$t('在全球各地通过 DAO 组织进行本地合规运营。'),
            },
            {
                img: require('./img/1030/view7-3.png'),
                title: this.$t('电商 RWA'),
                text: this.$t('第一个将现实世界电商完全放在链上运行的平台。'),
            },
        ]
    }
  },
}
</script>

<style scoped>
@import "./css/index.css";
.view7 {
    flex-direction: column;
    justify-content: center;

}

.view7 .ul {
    padding-top: 125px;
}

.view7 .li-box {
    padding-right: 45px;
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-self: stretch;
}

.view7 .li-box:last-child {
    padding-right: 0;
}

.view7 .li {
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.10);
    padding: 15px 22px 20px 0;
    box-sizing: border-box;
}

.view7 .li-img-box {
    justify-content: flex-start;
    height: auto;
}

.view7 .li-img {
    width: 182px;
}

.text-box {
    padding: 0 0 44px 24px;
    text-align: left;
}

.view7 .li-title {
    font-size: 24px;
    font-weight: 600;
}
.view7 .li-text {
    font-size: 16px;
    font-weight: 600;
    padding-top: 10px;
}
@media screen and (max-width: 768px) {
    .view7 .li-img-box {
        width: 80px;
        height: 80px;
        align-items: center;
        padding-bottom: 0;
    }
    .view7 ul {
        display: block;
    }
    .view7 .li {
        margin-bottom: .2rem;
        display: flex;
        align-items: center;
    }
    .view7 .li-box {
        width: 100%;
        padding-right: 0;

    }
    .view7 .li-img {
        width: 100%;
        height: 100%;
        margin-bottom: 0;
    }
    .text-box {
        flex: 1;
        box-sizing: border-box;
        padding: 0 0 0 6px;
    }
    .view7 .li-title {
        font-size: 18px;
    }
    .view7 .li-text {
        font-size: 14px;
        padding-top: 6px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/lobby/components1030/view7.vue